import en from './en'

// NOTE: DO NOT UPDATE THIS RESERVED TRANSLATION KEYS AND THEIR VALUES
const reservedTranslationsWithUniqueKeyNames = {
  '404': '404',
  leadingSpaceNotAllowed: 'Пробел в начале не допускается.',
  trailingSpaceNotAllowed: 'Пробел в конце не допускается.',
  mustbeAtleastCharacters: '{{label}} должен содержать не менее {{minNumber}} символов',
  cannotExceedCharacters: '{{label}} не может превышать {{maxNumber}} символов',
  numberMustbeAtleast: '{{label}} должен быть не меньше {{minNumber}}',
  numberCannotExceed: '{{label}} не может превышать {{maxNumber}}',
  isRequired: '{{label}} обязателен',
  emptySpaceNotContain: 'Это поле не может содержать пробел',
  register: 'Регистрация',
  login: 'Войти',
  comingSoon: 'Скоро',
  submit: 'Отправить',
  email: 'Эл. почта',
  termsConditions: 'Условия использования',
  password: 'Пароль',
  eighteenPlus: 'Мне больше 18 лет, и я принимаю Условия обслуживания',
  signUp: 'Регистрация',
  createNewAccount: 'Создать новый аккаунт',
  fullName: 'Полное имя',
  referralCode: 'Реферальный код',
  confirmPassword: 'Подтвердите пароль',
  facebook: ' Facebook',
  google: 'Google',
  haveAnAccount: 'Уже есть аккаунт? ',
  pageNotFound: 'Мы не можем найти страницу, которую вы ищете!',
  error: 'Ошибка',
  somethingWentWrong: 'Что-то пошло не так!',
  personalDetails: 'Личные данные',
  firstName: 'Имя',
  lastName: 'Фамилия',
  dateOfBirth: 'Дата рождения',
  phoneNumber: 'Номер телефона',
  change: 'Изменить',
  saveChanges: 'Сохранить изменения',
  currentPassword: 'Текущий пароль',
  newPassword: 'Новый пароль',
  myProfile: 'Мой профиль',
  transactions: 'Транзакции',
  deposit: 'Пополнить',
  withdraw: 'Вывести',
  referral: 'Реферал',
  changePassword: 'Сменить пароль',
  logout: 'Выйти',
  currency: 'Валюта.',
  view: 'Просмотр',
  ok: 'ОК',
  cancel: 'Отмена',
  userName: 'Имя пользователя',
  passwordRegexMatch: 'Пароль должен содержать одну заглавную букву, одну цифру и один специальный символ',
  invalidEmailFormat: 'Неверный формат эл. почты',
  noRecordsFound: 'Записи не найдены',
  backToLobby: 'Назад в лобби',
  placeBet: 'Сделать ставку',
  rOICalculator: 'Калькулятор ROI',
  activeBets: 'АКТИВНЫЕ СТАВКИ',
  closedBets: 'ЗАКРЫТЫЕ СТАВКИ',
  publicBets: 'ПУБЛИЧНЫЕ СТАВКИ',
  leaderboard: 'ТАБЛИЦА ЛИДЕРОВ',
  howToplay: 'Как играть',
  bustPriceLabel: 'Цена банкротства',
  multiplierLabel: 'МНОЖИТЕЛЬ',
  pnLFee: 'Комиссия PnL',
  flatFee: 'Фиксированная комиссия',
  takeProfitLabel: 'ЗАФИКСИРОВАТЬ ПРИБЫЛЬ ПО ЦЕНЕ',
  closeBetLabel: 'ЗАКРЫТЬ СТАВКУ ПО ЦЕНЕ',
  priceUpLabel: 'ЦЕНА ВЫРАСТЕТ ИЛИ УПАДЕТ?',
  payoutMul: 'МНОЖИТЕЛЬ ВЫПЛАТЫ',
  allCurrencies: 'Все валюты',
  monthLabel: 'Месяц',
  day: 'День',
  week: 'Неделя',
  betLabel: 'Метка ставки',
  entryPrice: 'Цена входа',
  closeBetErr: 'Введите допустимую сумму закрытия ставки',
  mulValErr: 'Значение множителя от 100 до 1000',
  profitErr: 'Введите допустимую сумму фиксации прибыли'
}

// NOTE: PLEASE ADD YOUR API SUCCESS MESSAGE TRANSLATIONS HERE ONLY
const apiSuccessMessagesTranslations = {
  loginSuccessfully: 'Вход выполнен успешно.',
  logoutSuccessfully: 'Выход выполнен успешно.',
  passwordUpdateSuccessfully: 'Пароль успешно обновлен.',
  updatePlayerStatusSuccessfully: 'Статус игрока успешно обновлен.',
  resetPasswordSuccessfully: 'Пароль успешно сброшен.',
  signupSuccessfully: 'Регистрация прошла успешно.',
  betPlacedSuccessfully: 'Ставка успешно размещена.',
  betCancelledSuccessfully: 'Ставка успешно отменена.'
}

// NOTE: PLEASE ADD YOUR API ERROR MESSAGE TRANSLATIONS HERE ONLY
const apiErrorMessagesTranslations = {
  UnAuthorized: 'Время сессии истекло',
  LoginFailedError: 'Ошибка входа',
  InvalidCredentialsError: 'Неверные учетные данные',
  InvalidTokenError: ' Токен недействителен',
  InvalidSessionError: ' Сессия истекла',
  CreateUserError: 'Не удалось создать пользователя',
  DataMismatchError: 'Данные не совпадают',
  UserNotFoundError: 'Пользователь не найден',
  DuplicateEmailError: 'Эл. почта уже существует',
  RequestInputValidationError: 'Проверьте данные запроса',
  ResponseInputValidationError: 'Проверка ответа не пройдена, см. JSON-схему ответа',
  SocketRequestInputValidationError: 'Проверьте данные запроса для socket-соединения',
  SocketResponseValidationError: 'Проверка ответа socket-соединения не пройдена, см. JSON-схему ответа',
  InternalServerError: 'Внутренняя ошибка сервера',
  InvalidSocketArgumentError: 'Укажите правильные аргументы: eventName, [payloadObject] и [callback]',
  InvalidCredentials: 'Учетные данные не совпадают',
  InvalidToken: 'Токен доступа не передан или истек',
  InvalidSession: 'Сессия пользователя недействительна, войдите снова',
  InvalidAccess: 'Доступ запрещен',
  NonOperationalError: 'На сервере произошла ошибка',
  UserNotExists: 'Пользователь не существует',
  InvalidAction: 'Недопустимое действие',
  SessionAlreadyStarted: 'Сессия уже начата',
  SessionNotStarted: 'Сессия не начата',
  EmailNotVerified: 'Эл. почта не подтверждена',
  InvalidGameTypeError: 'Настройки для указанного типа игры не найдены',
  InvalidGameRoundError: 'Игра по указанным данным не найдена',
  NoRoundRunningError: 'Сейчас нет активного раунда',
  NoPlacedBetFoundError: 'Размещенная ставка не найдена',
  NoWalletFoundError: 'Кошелек с указанными данными не найден',
  NotEnoughBalanceError: 'Баланса недостаточно для выполнения операции',
  AutoRateIsInvalidError: 'Автоставка вне допустимого предела',
  BetAmountIsNotInLimitError: 'Сумма ставки вне допустимых пределов',
  EmailNotFound: 'Эл. почта не найдена',
  UserNotAbove18YearsError: 'Пользователю нет 18 лет',
  InvalidBlockchainAddress: 'Неверный адрес блокчейна',
  AddressMismatch: 'Указанный адрес и восстановленный адрес не совпадают',
  NonceLifetimeExpired: 'Срок действия nonce истек',
  SomethingWentWrong: 'Что-то пошло не так',
  AccountNotActive: 'Аккаунт не активен',
  LoginTokenRequire: 'Требуется OTP (одноразовый пароль)',
  UserAlreadyExists: 'Пользователь уже существует',
  InvalidVerificationToken: 'Недействительный токен подтверждения',
  UserNotActive: 'Пользователь заблокирован, свяжитесь с администратором',
  FileUploadFailed: 'Не удалось загрузить изображение',
  EmailAlreadyVerified: 'Эл. почта уже подтверждена',
  InvalidReferralCode: 'Неверный реферальный код',
  InvalidAffiliateCode: 'Неверный партнерский код',
  RecordNotFound: 'Запись не найдена',
  WithdrawalRequestAlreadyPending: 'Запрос на вывод уже ожидает обработки',
  WalletDoesNotBelongToUser: 'Этот кошелек не принадлежит данному пользователю',
  BetAlreadyInProgress: 'Ставка уже выполняется',
  ServerSeedNotFoundErrorType: 'Серверный сид не найден, войдите снова',
  InvalidTileErrorType: 'Клетка должна быть в диапазоне от 1 до 25',
  FavoriteGameExistsErrorType: 'Избранная игра уже существует',
  FavoriteGameNotFoundErrorType: 'Избранная игра не найдена',
  TransactionAlreadyPendingErrorType: 'Транзакция уже ожидает обработки',
  UserHasNoActiveBonusErrorType: 'У пользователя нет активного бонуса',
  BonusExpiredErrorType: 'Срок бонуса истек',
  UserHasAlreadyActivatedBonusWageringErrorType: 'Пользователь уже активировал отыгрыш бонуса',
  InvalidRoundHashErrorType: 'Неверный хеш раунда',
  InvalidSignatureErrorType: 'Неверная подпись',
  UserHasNoBonusAmountToClaimErrorType: 'У пользователя нет суммы бонуса для получения',
  BonusNotExistsErrorType: 'Бонус не найден'
}

// NOTE: PLEASE ADD YOUR OTHER KEY TRANSLATIONS HERE ONLY
const otherTranslationKeys = {
  betAmount: 'Сумма ставки',
  betHistory: 'История ставок',
  provablyFair: 'Проверяемая честность',
  minimumBet: 'Минимальная ставка',
  maximumBet: 'Максимальная ставка',
  selectYourBetAmount: 'Выберите сумму ставки',
  buyInAmount: 'Сумма бай-ина',
  selectYourBuyInAmountFromGivenRange: 'Выберите сумму бай-ина из указанного диапазона',
  profitOnWin: 'Прибыль при выигрыше',
  noOfBets: 'Количество ставок',
  auto: 'Авто',
  half: '½',
  double: '2X',
  start: 'Старт',
  cancel: 'Отмена',
  prediction: 'Прогноз',
  luckyNumber: 'Счастливое число',
  multiplier: 'Множитель',
  chanceToWin: 'Шанс выигрыша',
  betBtn: 'Сделать ставку',
  bets: 'Ставки',
  depositBtn: 'Пополнить',
  rollOver: 'Больше',
  rollUnder: 'Меньше',
  invalidBetAmount: 'Недопустимая сумма ставки',
  maxBetAmountLimit: 'Превышен максимальный лимит ставки {{value}}',
  minBetAmountLimit: 'Минимальная ставка — {{value}}.',
  noBalance: 'Сумма ставки больше баланса кошелька',
  noAutoCashout: 'Требуется автоставка.',
  autoRateLimitWarning: 'Автоставка должна быть больше {{value}}'
}

// NOTE: PLEASE ADD YOUR PREDICTION MARKET TRANSLATIONS HERE ONLY
const predictionMarketTranslations = {
  error: 'Ошибка',
  somethingWentWrongPleaseTryAgain: 'Что-то пошло не так. Попробуйте еще раз.',
  market: 'Рынок',
  limit: 'Лимит',
  buy: 'Купить',
  sell: 'Продать',
  yes: 'Да',
  no: 'Нет',
  up: 'Вверх',
  down: 'Вниз',
  yesCents: 'Да {{cents}}¢',
  noCents: 'Нет {{cents}}¢',
  split: 'Сплит',
  merge: 'Слияние',
  amount: 'Сумма',
  shares: 'Доли',
  cancel: 'Отмена',
  submit: 'Отправить',
  refresh: 'Обновить',
  loading: 'Загрузка',
  loadMore: 'Загрузить еще',
  gotIt: 'Понятно',
  next: 'Далее',
  previous: 'Назад',
  trade: 'Торговать',
  portfolio: 'Портфель',
  rules: 'Правила',
  volume: 'Объем',
  category: 'Категория',
  notAvailable: 'Н/Д',
  open: 'Открыт',
  closed: 'Закрыт',
  removed: 'Удален',
  resolved: 'Разрешен',
  cancelled: 'Отменен',
  settled: 'Рассчитан',
  ask: 'Аск',
  bid: 'Бид',
  asks: 'Аски',
  bids: 'Биды',
  total: 'Итого',
  outcome: 'Исход',
  options: 'Варианты',
  history: 'История',
  positions: 'Позиции',
  orders: 'Ордера',
  activity: 'Активность',
  comments: 'Комментарии',
  delete: 'Удалить',
  reply: 'Ответить',
  postComment: 'Опубликовать комментарий',
  likeCount: 'Нравится ({{count}})',
  limitPrice: 'Лимитная цена',
  postOnly: 'Только в стакан',
  youPay: 'Вы платите',
  shareCost: 'Стоимость долей',
  toWin: 'К выигрышу',
  youWillReceive: 'Вы получите',
  averagePrice: 'Средняя цена',
  payable: 'К оплате',
  processingFee: 'Комиссия за обработку',
  processingFees: 'Комиссии за обработку',
  estProcessingFee: 'Ориент. комиссия за обработку',
  estProcessingFeeIncluded: 'Ориент. комиссия за обработку (включена)',
  processingFeeRefundable: 'Комиссия за обработку (возвращается)',
  showMore: 'показать еще...',
  feePerShareIfItFillsNow: 'Комиссия за долю, если исполнится сейчас',
  marketSettled: 'Рынок рассчитан',
  resultDeclared: 'Результат объявлен',
  tradingClosedForThisOption: 'Торговля по этому варианту закрыта.',
  waitingForNextMarket: 'Живого рынка пока нет. Торговля откроется с началом следующего окна.',
  cryptoLiveNavLabel: 'Live Crypto',
  goBack: 'Назад',
  yourPosition: 'Ваша позиция',
  availableToTrade: 'Доступно для торговли',
  locked: 'Заблокировано',
  profitLoss: 'П/У',
  yesShares: 'Доли Да',
  noShares: 'Доли Нет',
  avgYesPrice: 'Средняя цена Да',
  avgNoPrice: 'Средняя цена Нет',
  outcomeShares: 'Доли {{outcome}}',
  avgOutcomePrice: 'Средняя цена {{outcome}}',
  payoutProfitLoss: 'П/У выплаты',
  outcomeWon: '{{outcome}} победил',
  buyOutcome: 'Купить {{outcome}}',
  sellOutcome: 'Продать {{outcome}}',
  decreaseAmount: 'Уменьшить сумму',
  increaseAmount: 'Увеличить сумму',
  decreaseShares: 'Уменьшить доли',
  increaseShares: 'Увеличить доли',
  decreaseLimitPrice: 'Уменьшить лимитную цену',
  increaseLimitPrice: 'Увеличить лимитную цену',
  nobodySellingRightNow: 'Сейчас никто не продает. Попробуйте лимитный ордер, чтобы он мог ждать.',
  nobodyBuyingRightNow: 'Сейчас никто не покупает. Попробуйте лимитный ордер, чтобы он мог ждать.',
  tooMuchMaxBuy: 'Слишком много. Сейчас можно купить не больше {{amount}}$.',
  tooManySharesMaxSell: 'Слишком много долей. Сейчас можно продать не больше {{amount}}.',
  restAsMakerOnly: 'Только как мейкер; отклоняется, если заберет ликвидность',
  mergeMatchedSharesIntoCollateral: 'Объединить совпадающие доли Да и Нет обратно в обеспечение.',
  sharesPerSide: 'Доли (на сторону)',
  splitCollateralIntoShares: 'Разделить обеспечение на доли Да и Нет для этого рынка.',
  closeTradePanel: 'Закрыть панель торговли',
  openTradePanel: 'Открыть панель торговли',
  orderSummary: 'Сводка ордера',
  youSell: 'Вы продаете',
  youMerge: 'Вы объединяете',
  estProceedsAtMarket: 'Ориент. выручка по рынку',
  splitCollateral: 'Разделить обеспечение',
  mergeShares: 'Объединить доли',
  splitHasNoProcessingFee: 'У сплита нет комиссии за обработку.',
  mergeHasNoProcessingFee: 'У слияния нет комиссии за обработку.',
  includedInWhatYouPay: 'Включено в сумму оплаты. Применяется, когда ордер совпадает с доступными предложениями.',
  deductedFromWhatYouReceive: 'Вычитается из получаемой суммы, когда ордер совпадает с доступными бидами.',
  heldWithYourOrder: 'Удерживается с ордером. Возвращается, если ордер ждет в стакане. Удерживается только при немедленном исполнении.',
  onlyIfOrderFillsRightAway: 'Только если ордер исполнится сразу — вычитается из выручки. Без комиссии, если он ждет в стакане.',
  makerFeeRebateExplanation: 'Если кто-то заберет ваш ожидающий ордер, вы можете получить {{rebatePercent}}% от его комиссии.',
  postOnlyOrderExplanation: 'Только в стакан: этот ордер только ждет. Если он исполнился бы сразу, он отменяется и деньги возвращаются.',
  notEnoughMoneyInWallet: 'Недостаточно денег в кошельке.',
  notEnoughYesAndNoSharesToMerge: 'Недостаточно долей Да и Нет для слияния.',
  notEnoughSharesToSell: 'У вас нет столько долей для продажи.',
  maxOrderSizeIs: 'Максимальный размер ордера — {{amount}}.',
  orderCrossesOwnSellOrder: 'Ордер пересек бы вашу собственную продажу по этому исходу. Сначала отмените или снизьте эту продажу.',
  orderCrossesOwnOppositeBuy: 'Ордер пересек бы вашу покупку противоположной стороны (Да+Нет >= 100¢). Сначала отмените или измените этот ордер.',
  orderCrossesOwnBuyOrder: 'Ордер пересек бы вашу собственную покупку по этому исходу. Сначала отмените или повысьте эту покупку.',
  placedBuyLimitOrder: 'Размещен лимитный ордер на покупку {{shares}} долей по цене {{price}}',
  placedSellLimitOrder: 'Размещен лимитный ордер на продажу {{shares}} долей по цене {{price}}',
  placedBuyMarketOrder: 'Размещен рыночный ордер на покупку на сумму {{amount}}',
  placedSellMarketOrder: 'Размещен рыночный ордер на продажу {{shares}} долей',
  mergedYesAndNoShares: 'Объединено {{quantity}} долей да и нет в сумму {{amount}}',
  splitAmountIntoYesAndNoShares: 'Сумма {{amount}} разделена на {{yesShares}} долей да и {{noShares}} долей нет',
  closedBuyLimitOrder: 'Закрыт лимитный ордер на покупку {{remainingShares}} долей по цене {{price}}, всего {{shares}}',
  closedSellLimitOrder: 'Закрыт лимитный ордер на продажу {{remainingShares}} долей по цене {{price}}, всего {{shares}}',
  closedBuyMarketOrder: 'Закрыт рыночный ордер на покупку на сумму {{remainingAmount}}, всего {{amount}}',
  closedSellMarketOrder: 'Закрыт рыночный ордер на продажу {{remainingShares}} долей, всего {{shares}}',
  boughtSharesFromSeller: 'Куплено {{quantity}} долей по цене {{price}} у {{sellerName}}',
  soldSharesToBuyer: 'Продано {{quantity}} долей по цене {{price}} покупателю {{buyerName}}',
  marketResolvedWithOutcome: 'Рынок разрешен с исходом {{outcome}}. Выплата: ${{payout}} ({{winningShares}} выигрышных долей).',
  buyerReceivedSharesSystemMinted: '{{buyerName}} получил {{quantity}} долей по {{price}} (выпущены системой)',
  buyerBoughtSharesFromSeller: '{{buyerName}} купил {{quantity}} долей по {{price}} у {{sellerName}}',
  sellerSoldSharesToSystem: '{{sellerName}} продал {{quantity}} долей по {{price}} системе SYSTEM',
  sellerSoldSharesToBuyer: '{{sellerName}} продал {{quantity}} долей по {{price}} покупателю {{buyerName}}',
  notifications: 'Уведомления',
  unreadNotifications: '{{count}} непрочитанных уведомлений',
  recentCount: '{{count}} недавних',
  loadingNotifications: 'Загрузка уведомлений...',
  noNotificationsYet: 'Уведомлений пока нет. Вы получите уведомление, когда ордера будут сопоставлены, завершены или рынки будут разрешены.',
  activityUpdate: 'Обновление активности',
  marketResolved: 'Рынок разрешен',
  marketQuestionResolved: 'Рынок "{{questionTitle}}" разрешен.',
  walletUpdated: 'Кошелек обновлен',
  justNow: 'Только что',
  pickAMarket: 'Выберите рынок',
  pickAMarketDescription: 'Откройте любой рынок и выберите Да или Нет по своему прогнозу. Затем используйте панель ордера, чтобы получить доли.',
  preferLimitOrders: 'Предпочитайте лимитные ордера',
  preferLimitOrdersDescription: 'Начните здесь. Укажите точную цену (¢) и число долей. Ордер остается в стакане, пока кто-то его не сопоставит — так вы контролируете цену.',
  noFillUseSplit: 'Нет исполнения? Используйте сплит',
  noFillUseSplitDescription: 'Если ликвидности не хватает для лимитного ордера, разделите обеспечение на равные доли Да и Нет. Затем можно продать ненужную сторону.',
  needSpeedMarketOrders: 'Нужна скорость? Рыночные ордера',
  needSpeedMarketOrdersDescription: 'Рыночные ордера исполняются мгновенно по текущему стакану. Используйте их, когда нужны доли сейчас и вы готовы платить рыночную цену.',
  holdOrCashOut: 'Держать или выйти',
  holdOrCashOutDescription: 'Продайте в любой момент до разрешения или держите до расчета. Выигрышные доли платят по $1; проигрышные рассчитываются по $0.',
  restsOnTheBookUntilMatched: 'Остается в стакане до сопоставления',
  convertCashIntoYesAndNoShares: 'Конвертировать деньги в доли Да + Нет',
  estShares: 'Ориент. доли',
  fillsInstantlyAtBookPrices: 'Исполняется сразу по ценам стакана',
  resolvedYes: 'Разрешен · Да',
  payoutCredited: 'Выплата зачислена',
  closeHowItWorks: 'Закрыть «Как это работает»',
  tryItOut: 'Попробовать?',
  willThereBeAUsRecessionThisYear: 'Будет ли рецессия в США в этом году?',
  exitTutorialAndReturnToMarkets: 'Выйти из обучения и вернуться к рынкам',
  exitDemo: 'Выйти из демо',
  howItWorks: 'Как это работает',
  demoGuide: 'Гид',
  demoGuideReopen: 'Открыть демо-гид снова',
  demoGuideSkip: 'Пропустить гид',
  demoGuideFinish: 'Готово',
  demoGuideStepOf: 'Шаг {{current}} из {{total}}',
  demoGuideBack: 'Назад',
  demoGuideWelcomeTitle: 'Добро пожаловать на площадку',
  demoGuideWelcomeBody: 'Это безопасный демо-рынок с игровыми деньгами. Я покажу каждый элемент интерфейса и объясню, что он делает — попробуйте действие или нажмите «Далее» в любой момент.',
  demoGuideWelcomeHint: 'Вы начинаете с демо-баланса $1000. Здесь ничего не настоящее.',
  demoGuideLimitTitle: 'Предпочитайте лимитные ордера',
  demoGuideLimitBody: 'Лимитный ордер позволяет задать точную цену (¢) и число долей. Он остается в стакане до сопоставления — вы контролируете цену, а не берете текущую.',
  demoGuideLimitHint: 'Я открыл лимит и предложил Купить Да по 45¢ × 10. Отправьте, если хотите попробовать, или «Далее», чтобы читать дальше.',
  demoGuideOrderbookTitle: 'Ваш ордер в стакане',
  demoGuideOrderbookBody: 'Стакан показывает ожидающие биды и аски. Когда вы размещаете лимитный ордер, он появляется здесь (часто с меткой «Вы»), пока не исполнится или не будет отменен.',
  demoGuideOrderbookHint: 'Если ожидающего ордера еще нет, я размещу небольшой демо-бид, чтобы было видно, как это выглядит.',
  demoGuidePostOnlyTitle: 'Только в стакан (только мейкер)',
  demoGuidePostOnlyBody: 'Только в стакан значит, что лимитная покупка ждет только как мейкер. Если цена исполнилась бы сразу против аска, ордер отклоняется и деньги возвращаются — полезно, если вы не хотите забирать ликвидность.',
  demoGuidePostOnlyHint: 'Режим «только в стакан» включен, готов непересекающийся бид 45¢. Отправьте или нажмите «Далее».',
  demoGuideCancelTitle: 'Отменить ожидающий ордер',
  demoGuideCancelBody: 'Передумали? Открытые ордера находятся в «Моя позиция». Отмена освобождает деньги, зарезервированные на покупках (или доли, заблокированные на продажах).',
  demoGuideCancelHint: 'Нажмите «Отмена» в строке, если хотите попрактиковаться — для вас оставлен ожидающий бид.',
  demoGuideMarketTitle: 'Нужна скорость? Рыночные ордера',
  demoGuideMarketBody: 'Рыночные ордера исполняются сразу по текущему стакану. Используйте их, когда нужны доли сейчас и вы готовы платить живые цены аска, а не ждать свой лимит.',
  demoGuideMarketHint: 'Я установил покупку на $5 по рынку. Отправьте, чтобы увидеть мгновенное исполнение, или «Далее».',
  demoGuideMintTitle: 'Нет асков? Выпуск все равно работает',
  demoGuideMintBody: 'Если никто не продает, доли все равно можно получить. Движок может выпустить Да+Нет из обеспечения, сопоставив вашу покупку с бидом противоположной стороны — пустые аски не всегда значат «застряли».',
  demoGuideMintHint: 'Я очистил аски этого варианта. Готова рыночная покупка на $5 — доли появятся даже при пустой стороне аска.',
  demoGuideSplitTitle: 'Нет исполнения? Используйте сплит',
  demoGuideSplitBody: 'Сплит мгновенно превращает обеспечение в равные доли Да и Нет — без контрагента. Удобно, когда стакан тонкий и нужен запас, чтобы позже продать ненужную сторону.',
  demoGuideSplitHint: 'Я предложил разделить $10. Попробуйте, чтобы увидеть рост Да и Нет, или нажмите «Далее».',
  demoGuideMergeTitle: 'Слить обратно в деньги',
  demoGuideMergeBody: 'Слияние — это обратный сплит: сжечь равные доли Да и Нет и вернуть обеспечение. Полезно, когда у вас обе стороны и нужно вернуться в деньги.',
  demoGuideMergeHint: 'Я предложил слить по 5 с каждой стороны. Нужны доступные Да и Нет — сначала сделайте сплит, если нужно.',
  demoGuideResolveTitle: 'Закрыть и рассчитать',
  demoGuideResolveBody: 'Когда торговля заканчивается, рынок закрывается и затем рассчитывается. Выигрышные доли платят по $1; проигрышные — по $0. В демо «Управление рынком» позволяет смоделировать закрытие → выбор победителя → расчет.',
  demoGuideResolveHint: 'Откройте панель, если она закрыта. Сначала закройте, затем выберите Да/Нет и рассчитайте выбранный вариант.',
  demoGuideDoneTitle: 'Основы у вас есть',
  demoGuideDoneBody: 'Лимит для контроля цены, только в стакан чтобы оставаться мейкером, отмена чтобы освободить резерв, рынок для скорости, выпуск когда аски пусты, сплит/слияние для запаса и управление рынком для разрешения.',
  demoGuideDoneHint: 'Повторите в любой момент кнопкой «Гид». Демо-деньги сбрасываются при повторном входе в демо.',
  demoGuideWaitingForAction: 'Завершите выделенное действие, чтобы продолжить.',
  demoGuideDoThisFirst: 'Сначала сделайте это',
  ganamosPolyTrade: 'Ganamos PolyTrade',
  trending: 'В тренде',
  new: 'Новое',
  buyYes: 'Купить Да',
  breaking: 'Срочно',
  noBreakingMarketsRightNow: 'Срочных рынков сейчас нет.',
  backToMarkets: 'Назад к рынкам',
  markets: 'Рынки',
  openFullMarket: 'Открыть полный рынок',
  tradeMarket: 'Торговать рынок',
  previousMarket: 'Предыдущий рынок',
  nextMarket: 'Следующий рынок',
  breakingMarkets: 'Срочные рынки',
  showBreakingMarket: 'Показать срочный рынок {{index}}',
  featuredMarkets: 'Избранные рынки',
  topMovers: 'Лидеры движения',
  viewAll: 'Смотреть все',
  liveTrades: 'Сделки в реальном времени',
  live: 'Эфир',
  featuredMarket: 'Избранный рынок',
  untitledMarket: 'Рынок без названия',
  traders: 'Трейдеры',
  endsIn: 'Заканчивается через',
  tradeNow: 'Торговать сейчас',
  showFeaturedMarket: 'Показать избранный рынок {{index}}',
  openNewsHeadline: 'Открыть новость: {{headline}}',
  openNewsStatus: 'Открыть новость: {{statusText}}',
  news: 'Новости',
  minimizeNews: 'Свернуть новости',
  expandNews: 'Развернуть новости',
  closeNews: 'Закрыть новости',
  liveWire: 'Лента новостей',
  categoryNews: 'Новости: {{category}}',
  categoryDesk: 'Редакция {{category}}',
  topHeadlinesAndRelatedCoverage: 'Главные заголовки и связанные материалы по этой категории рынка',
  topHeadlinesCount: 'Топ {{count}} заголовков',
  moreRelevantNews: 'Еще релевантные новости',
  noNewsStoriesForThisCategoryYet: 'Новостей по этой категории пока нет.',
  pullingHeadlinesFromTheWire: 'Загружаем заголовки из ленты…',
  scanningWire: 'Просматриваем ленту…',
  categoryWaitingForStories: '{{category}} · ожидание материалов',
  categoryStoriesCount: '{{category}} · {{count}} материалов',
  searchMarkets: 'Поиск рынков...',
  searchPortfolioActivity: 'Поиск активности портфеля',
  refreshPortfolioActivity: 'Обновить активность портфеля',
  portfolioSections: 'Разделы портфеля',
  noPositionsFound: 'Позиции не найдены',
  yourOwnedPositionsWillAppearHere: 'Ваши позиции появятся здесь.',
  noOrdersFound: 'Ордера не найдены',
  marketOrdersWillAppearInThisSection: 'Рыночные ордера появятся в этом разделе.',
  limitOrdersWillAppearInThisSection: 'Лимитные ордера появятся в этом разделе.',
  noActivityYet: 'Активности пока нет',
  completedTradesAndSettlementsWillBeListedHere: 'Завершенные сделки и расчеты будут показаны здесь.',
  cancelThisOrder: 'Отменить этот ордер?',
  cancelThisOrderDescription: 'Это удалит ваш открытый лимитный ордер из стакана. Новый можно разместить в любой момент.',
  keepOrder: 'Оставить ордер',
  cancelOrder: 'Отменить ордер',
  yourTradingDesk: 'Ваш торговый стол',
  stateFilters: 'Фильтры состояния',
  tablePagination: 'Постраничная навигация таблицы',
  pagination: 'Страницы',
  previousPage: 'Предыдущая страница',
  nextPage: 'Следующая страница',
  noDataAvailable: 'Нет данных',
  dataWillAppearHere: 'Данные появятся здесь',
  thumbnail: 'Миниатюра',
  actions: 'Действия',
  rowThumbnail: 'Миниатюра строки',
  yourPerformance: 'Ваши результаты',
  walletBalance: 'Баланс кошелька',
  totalProfitIncludingTakerFee: 'Общая прибыль с учетом комиссии тейкера',
  totalProfit: 'Общая прибыль',
  hideTakerFee: 'Скрыть комиссию тейкера',
  showTakerFee: 'Показать комиссию тейкера',
  profitOverTime: 'Прибыль во времени',
  noChartDataAvailable: 'Нет данных для графика',
  profitHistoryWillAppearAsTradesArePlaced: 'История прибыли появится по мере совершения сделок.',
  profitChartTimeRange: 'Период графика прибыли',
  userActivity: 'Активность пользователя',
  userActivityTitle: 'Активность пользователя',
  userActivityTabs: 'Вкладки активности пользователя',
  refreshUserActivity: 'Обновить активность пользователя',
  addYourComment: 'Добавьте комментарий',
  shareYourThoughtsAboutThisMarket: 'Поделитесь мнением об этом рынке...',
  anonymous: 'аноним',
  hideReplies: 'Скрыть ответы',
  showReplies: 'Показать ответы',
  writeAReply: 'Напишите ответ...',
  loadingEllipsis: 'Загрузка...',
  recentMarketBuysAndSellsWillAppearHere: 'Недавние рыночные покупки и продажи появятся здесь.',
  topHolders: 'Крупнейшие держатели',
  topPositions: 'Топ позиций',
  noTopPositionsFound: 'Топ позиций не найден',
  topPositionsWillAppearHereWithHighestRealizedPnl: 'Здесь появятся позиции с наибольшим реализованным PNL',
  yesHolders: 'Держатели Да',
  noHolders: 'Держатели Нет',
  noTopHoldersFoundForYesOutcome: 'Крупнейшие держатели исхода Да не найдены',
  topHoldersWillAppearHereForYesOutcome: 'Здесь появятся крупнейшие держатели исхода Да',
  noTopHoldersFoundForNoOutcome: 'Крупнейшие держатели исхода Нет не найдены',
  topHoldersWillAppearHereForNoOutcome: 'Здесь появятся крупнейшие держатели исхода Нет',
  optionDetailsTabs: 'Вкладки сведений о варианте',
  orderbookOutcome: 'Исход стакана',
  orderbook: 'Стакан',
  graph: 'График',
  myPosition: 'Моя позиция',
  yesBook: 'Стакан Да',
  noBook: 'Стакан Нет',
  spread: 'Спред',
  you: 'Вы',
  noAsks: 'Нет асков',
  noBids: 'Нет бидов',
  loadingPosition: 'Загрузка позиции...',
  yourOrders: 'Ваши ордера',
  marketOrdersForThisOptionWillAppearHere: 'Рыночные ордера по этому варианту появятся здесь.',
  limitOrdersForThisOptionWillAppearHere: 'Лимитные ордера по этому варианту появятся здесь.',
  rulesAndMarketContext: 'Правила и контекст рынка',
  marketResolvesBasedOnListedCriteriaAndFinalOutcomeData: 'Рынок разрешается по указанным критериям и итоговым данным исхода.',
  matchingEngineSettlesOpenOrdersUsingMarketResolutionRules: 'Матчинг-движок рассчитывает открытые ордера по правилам разрешения рынка.',
  ambiguousOutcomesAreHandledByPlatformAdjudicationPolicy: 'Неоднозначные исходы рассматриваются по политике арбитража платформы.',
  defaultPredictionMarketRules: `
  Правила:
  - Этот рынок разрешается по исходу, описанному в вопросе. Для разрешения используются общедоступные и надежные источники, такие как официальные заявления, проверенные поставщики данных или авторитетные новостные организации. 
  - Если исход станет ясен до указанной даты окончания, рынок может быть разрешен раньше. Если событие нельзя определить или вопрос станет неоднозначным, платформа может разрешить рынок по своему обоснованному суждению на основе доступной информации.
  - Все разрешения окончательны.`,
  pleaseLogInToFavouriteQuestions: 'Войдите, чтобы добавлять вопросы в избранное.',
  removeFromFavourites: 'Удалить из избранного',
  addToFavourites: 'Добавить в избранное',
  unableToUpdateFavouriteQuestionPleaseTryAgain: 'Не удалось обновить избранный вопрос. Попробуйте еще раз.',
  marketOrderInProgress: 'Рыночный ордер выполняется',
  noActiveMarketOrder: 'Нет активного рыночного ордера',
  marketOrderRunning: 'Рыночный ордер выполняется',
  remainingAmount: 'Осталось: ${{amount}}',
  remainingShares: 'Осталось: {{shares}} долей',
  statusState: 'Статус: {{state}}',
  noMarketOrderRunning: 'Нет выполняемого рыночного ордера. Прошлые рыночные ордера — на вкладке «Ордера» страницы портфеля.',
  deposit: 'Пополнить',
  withdraw: 'Вывести',
  closeWalletActivityModal: 'Закрыть окно активности кошелька',
  enterAmountToAction: 'Введите сумму для {{action}}',
  depositSuccessful: 'Пополнение успешно',
  depositFailedPleaseTryAgain: 'Пополнение не удалось. Попробуйте еще раз.',
  withdrawalSuccessful: 'Вывод успешен',
  withdrawFailedPleaseTryAgain: 'Вывод не удался. Попробуйте еще раз.',
  mergeSuccessfulBalanceCredited: 'Слияние успешно. Баланс зачислен.',
  mergeSuccessfulCreditPending: 'Слияние успешно. Зачисление ожидается — баланс скоро обновится.',
  orderPlacedSuccessfully: 'Ордер успешно размещен',
  placeOrderFailedPleaseTryAgain: 'Не удалось разместить ордер. Попробуйте еще раз.',
  orderCancelledSuccessfully: 'Ордер успешно отменен',
  cancelLimitOrderFailedPleaseTryAgain: 'Не удалось отменить лимитный ордер. Попробуйте еще раз.',
  commentAdded: 'Комментарий добавлен',
  addCommentFailedPleaseTryAgain: 'Не удалось добавить комментарий. Попробуйте еще раз.',
  commentDeleted: 'Комментарий удален',
  deleteCommentFailedPleaseTryAgain: 'Не удалось удалить комментарий. Попробуйте еще раз.',
  failedToLoadNotifications: 'Не удалось загрузить уведомления',
  commentCannotBeEmpty: 'Комментарий не может быть пустым.',
  commentNotFound: 'Комментарий не найден.',
  demoMultiOutcomeMarket: 'Демо-рынок с несколькими исходами',
  outcomeAlpha: 'Исход Альфа',
  outcomeBeta: 'Исход Бета',
  outcomeGamma: 'Исход Гамма',
  greatMarketToLearnLimitOrders: 'Хороший рынок, чтобы изучить лимитные ордера — попробуйте бид ниже текущей цены.',
  theOrderbookUpdatesLiveOnceYouStartPlacingDemoOrders: 'Стакан обновляется в реальном времени, как только вы размещаете демо-ордера.',
  demoOutcome: 'Демо-исход',
  demoMarketControls: 'Управление демо-рынком',
  simulateCloseAndSettlementToSeeHowTheMarketBehaves: 'Смоделируйте закрытие и расчет, чтобы увидеть, как ведет себя рынок.',
  closePanel: 'Закрыть панель',
  closeMarket: 'Закрыть рынок',
  tradingOpen: 'Торговля открыта',
  stopsTradingClearsTheOrderbookAndClosesOpenOrders: 'Останавливает торговлю, очищает стакан и закрывает открытые ордера. Оставшиеся предоплаченные суммы по бидам возвращаются в кошелек. Позиции открыты до расчета.',
  marketClosed: 'Рынок закрыт',
  settleMarket: 'Рассчитать рынок',
  ready: 'Готово',
  awaitingClose: 'Ожидает закрытия',
  pickTheWinningOutcomeDescription: 'Выберите выигрышный исход. Выигрышные доли платят по $1, позиции очищаются, а варианты показываются как рассчитанные с итоговым результатом.',
  winningOutcome: 'Выигрышный исход',
  settlementOutcome: 'Исход расчета',
  closeManageMarketPanel: 'Закрыть панель управления рынком',
  manageMarket: 'Управлять рынком',
  manageDemoMarket: 'Управлять демо-рынком',
  noChartDataYet: 'Данных графика пока нет',
  priceHistoryWillAppearHereAsTradesHappen: 'История цен появится здесь по мере сделок.',
  chartTimeRange: 'Период графика',
  allMarkets: 'Все рынки',
  backToCollateral: 'Назад к обеспечению · {{marketTitle}}',
  demo: 'Демо',
  depositing: 'Пополнение...',
  equalYesAndNoShares: 'Равные доли Да и Нет · {{marketTitle}}',
  estValue: 'Ориент. {{value}}',
  favouriteQuestions: 'Избранные вопросы',
  favourites: 'Избранное',
  feePerShareFormula: 'Комиссия за долю (¢) = цена × (100 − цена) × {{coefficient}} / 10,000',
  limitBuy: 'Лимитная покупка',
  limitSell: 'Лимитная продажа',
  marketBuyOn: 'Рыночная покупка на {{marketTitle}}',
  marketSellOn: 'Рыночная продажа на {{marketTitle}}',
  marketResolutionPayoutReceived: 'Получена выплата по разрешению рынка. Новый баланс: {{currency}} {{formattedBalance}}',
  marketsPagination: 'Страницы рынков',
  noFavouriteQuestionsYet: 'Избранных вопросов пока нет.',
  noTitle: 'Без названия',
  optionNumber: 'Вариант {{number}}',
  postOnlyLimitBuy: 'Лимитная покупка только в стакан',
  system: 'СИСТЕМА',
  unknownOrderType: 'Неизвестный тип ордера: {{orderType}}',
  withdrawing: 'Вывод...',
  yourBalanceWasCredited: 'Ваш баланс зачислен. Новый баланс: {{currency}} {{formattedBalance}}',
  yourBalanceWasDebited: 'Ваш баланс списан. Новый баланс: {{currency}} {{formattedBalance}}',
  thisMarket: 'этот рынок',
  yourPositionText: 'ваша позиция',
  amountYesAndNo: '{{amount}} Да + {{amount}} Нет',
  daysAgo: '{{days}} дн. назад',
  hoursAgo: '{{hours}} ч. назад',
  minutesAgo: '{{minutes}} мин. назад',
  outcomeSharesAtMarket: 'доли {{outcome}} по рынку',
  sharesYesAndNo: '{{shares}} Да + {{shares}} Нет',
  sharesOutcomeAtPrice: '{{shares}} {{outcome}} @ {{price}}¢ · {{marketTitle}}',
  sharesOutcome: '{{shares}} долей {{outcome}}'
}


/**
 * NOTE:
 * =================================================================================================
 * Please go through this spreading objects first before adding new translation key. So that the
 * duplicate translations will not be created and help us to maintain the consitency of code.
 * If you didn't find any of translation as per your requirement in reserve or api success & error
 * msg translation object, Please add new translation with unique key name in otherTranslationKeys
 * Object. Unique key names help us to avoid overriding of translations.
 * =================================================================================================
 */
export default {
  ...en,
  ...reservedTranslationsWithUniqueKeyNames,
  ...apiSuccessMessagesTranslations,
  ...apiErrorMessagesTranslations,
  ...otherTranslationKeys,
  ...predictionMarketTranslations
}
